import { render, staticRenderFns } from "./ChatComponent.vue?vue&type=template&id=0e460eb3&scoped=true"
import script from "./ChatComponent.vue?vue&type=script&lang=js"
export * from "./ChatComponent.vue?vue&type=script&lang=js"
import style0 from "./ChatComponent.vue?vue&type=style&index=0&id=0e460eb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e460eb3",
  null
  
)

export default component.exports